module.exports = __webpack_public_path__ + "img/chevron-up-circle-outline-red.7bf82d00.svg";